import _objectSpread from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
export var createMapSubscribableThing = function createMapSubscribableThing(wrapSubscribeFunction) {
  return function (subscribableThing, map) {
    return wrapSubscribeFunction(function (observer) {
      return subscribableThing(_objectSpread({}, observer, {
        next: function next(value) {
          return observer.next(map(value));
        }
      }));
    });
  };
};